module.exports = __webpack_public_path__ + "media/button_click.f8295e31.wav";